<template>
    <div class="pay">
          <div class="header">
      <rs-row>
        <rs-col :span="24">
          <div class="grid-content bg-purple-dark">
            <img
              @click="back"
              style="cursor: pointer; width: 20px; height: 20px"
              src="../assets/返回.png"
              alt=""
            />
            <span style="margin-left: 10px">缴费确认</span>
          </div></rs-col
        >
      </rs-row>
    </div>
    <div class="main">
        <div class="contractCode">
        <div>
          <div>缴费总金额（元）</div>
          <div class="contractCodecolor">{{ amountpaid }} <span></span></div>
        </div>
        <!-- <div>
          <div>当期缴费金额(元)</div>
          <div>{{ Currentnumber }} <span></span></div>
        </div>
        <div>
          <div>已缴总金额（元）</div>
          <div>{{ PaidAmount }} <span></span></div>
        </div> -->
        <div>
          <div>缴费数量</div>
          <div>{{num}}</div>
        </div>
      </div>
      <div class="resultContent" style="margin-top: -45px">
        <renderTable
          class="row-click"
          :list="tableData"
          :columns="tableColumns"
          border
          ref="multipleTable"
          @selection-change="handleSelectionChange"
        >
          <rs-table-column type="selection" width="155px"> </rs-table-column>

          <rs-table-column
            label="合同号"
            slot="contractCode"
            sortable
            width="160px"
          >
            <template slot-scope="scope">
              <span
                @dbclick.stop="toDetails(scope.row.id)"
                style="cursor: pointer"
                >{{ scope.row.contractCode }}</span
              >
            </template>
          </rs-table-column>

          <rs-table-column
            label="铺位号"
            slot="boothCode"
            width="160px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.boothList" :key="index">
                <span v-if="index != 0">|</span>
                {{ item.boothCode }}
              </span>
            </template>
          </rs-table-column>
          <rs-table-column
            label="操作"
            slot="operation"
            fixed="right"
            width="240px"
          >
            <!-- <template slot-scope="scope"> </template> -->
          </rs-table-column>
        </renderTable>

        <!-- 分页 -->
        <rs-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 200, 300, 400]"
          :page-size="pageSize"
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          layout="total,prev, pager, next, sizes, jumper"
          :total="total"
        ></rs-pagination>
      </div>
     
     </div>
     <div class="fotter">
         <div class="main_Fotter">
          请选择支付方式： <rs-radio v-model="radio" label="1">个人网银</rs-radio>
  <rs-radio v-model="radio" label="2">pos</rs-radio>
   <rs-radio v-model="radio" label="3">支付宝</rs-radio>
  <rs-radio v-model="radio" label="4">微信</rs-radio>
      </div>
     </div>
      <div class="footer">
          <rs-button @click="cale">取消支付</rs-button>
           <rs-button type="primary" @click="submit">确认支付</rs-button>
           
      </div>
    </div>
</template>
<script>
	import API from "@/api/pay";
	import utils from "@/utils/utils";
export default {
    data(){
        return{
            radio:'3',
            amountpaid:0,
            tableColumns:[],
tableData: [],
num:'',
searchForm: {
        contractCode: "",
        beginDate: [],
        shopId: "",
      },
      // wholeReceptiontabData: [],
      // wholeRecepData: [],
      // wholeRecepliushuiData: [],
      // tableColumns: [],

      // ruleForm: [],
      // tmpRuleForm: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
	  val:'',
	  amountpaid:''
        }
    },
	mounted() {
		this.handleQuery()
		this.amountobepaid()
	},
    created(){
		this.bus.$on('val',(val)=>{
			this.val=val
		})
  this.renderPage();
    },
    methods:{
		amountobepaid() {
		  let params = {
		    businessId: this.shopVo,
		    paymentDueBeginDate: "",
		    paymentDueEndDate: "",
		    contractCode: this.searchForm.contractCode,
		    itemCode:'1001',
		     paidStatus:0
		  };
		  API.paygetTotalUnpaidAmount(params).then((res) => {
		    if (res.data.code == 200) {
		      console.log("获取合同列表222", res);
		      this.amountpaid = res.data.data;
			  console.log(this.amountpaid)
			  this.num=res.data.data.total
			  console.log(res.data.data)
		    }
		  });
		},
		// 列表API数据
		handleQuery() {
		  let pageNum = this.pageNum;
		  let pageSize = this.pageSize;
		  // console.log(this.searchForm, "kanakn");
		  let params = {
		    pageSize,
		    pageNum,
		    ...this.searchForm,
		     itemCode:'1001',
		    paidStatus: 0,
		    shopId: this.shopVo,
		  };
		  // params = this.turnParams(params);
		  API.page(params)
		    .then((res) => {
		      if (res.data.code == 200) {
		        console.log("获取合同列表", res);
		        this.tableData = res.data.data.list;
		        console.log('合同号',res.data.data.list)
		  //       for(var i=0;i<this.tableData.length;i++){
		  //            if(this.Contract.indexOf(this.tableData[i].contractCode)==-1){
						 // console.log(this.tableData[i].contractCode)
		  //              this.Contract.push(this.tableData[i].contractCode)
		  //            }
		  //       }
		        console.log(this.Contract)
		        this.total = res.data.data.total;
		      }
		    })
		    .finally(() => {
		      utils.hideLoading();
		    });
		},
        //取消支付
        cale(){
           this.$router.go(-1)
        },
        //支付
submit(){
    let params = {
        statementNo: this.categoryList,
        itemCode:'1001',
        businessId: this.classirerslist,
      };
      console.log(params)
      API.unifiedPreOrder7011(params).then((res) => {
        if (res.data.code == 200) {
          console.log("获取合同列表", res);

          window.open(res.data.data.pc_cashier_url);
          let params = {
            merOrderNo: res.data.data.merOrderNo,
          };
          API.getPayRecordByMerOrderNo(params).then((res) => {
            if (res.data.code == 200) {
              console.log("获取合同列表", res);

            } 
          });
        } else {
        }
      });
},

        //获取
    handleSelectionChange(val) {
		this.bus.$emit('val',val)
      this.multipleSelection = val;
      console.log(this.multipleSelection);
      var categorystr = "";
      var classifystr = "";
      var classirerstr = "";
      this.multipleSelection.forEach(function (c) {
        categorystr += c.statementNo + ",";
        classifystr += c.itemCode + ",";
        classirerstr += c.businessId + ",";
      });
      categorystr = categorystr.substring(0, categorystr.length - 1);
      console.log(categorystr);
      classifystr = classifystr.substring(0, classifystr.length - 1);
      classirerstr = classirerstr.substring(0, classirerstr.length - 1);
      // this.categoryList = categorystr.split(",");
      // this.classifystr = classifystr.split(",");
      // this.classirerslist = classirerstr.split(",");
      this.categoryList = categorystr;
      this.classifystr = classifystr;
      this.classirerslist = classirerstr;
      // console.log(str)
      console.log(this.categoryList);
      console.log(this.classifystr);
      console.log(this.classirerslist);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.handleQuery();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.handleQuery();
    },
        back(){
            this.$router.go(-1)
        },
         renderPage() {
      this.tableColumns = [
        {
          width: 40,
          type: "selection",
          fixed: true,
        },
         {
type: "index",
          label: "序号",
          minWidth: "50px",
          // sortable: true,
         },
       
        {
          prop: "boothCode",
          label: "铺位号",
          minWidth: "120px",
          // sortable: true,
        },
        {
          prop: "buildingName",
          label: "楼栋",
          minWidth: "120px",
          // sortable: true,
        },
        {
          prop: "floorName",
          label: "楼层",
          minWidth: "120px",
          // sortable: true,
        },
        {
          prop: "statementBeginEndTime",
          label: "账单周期",
          minWidth: "120px",
          // sortable: true,
        },
        {
          prop: "paymentDue",
          label: "付款日期",
          minWidth: "120px",
          // sortable: true,
        },
        {
          prop: "receivableAmount",
          label: "缴纳金额（元）",
          minWidth: "120px",
          // sortable: true,
        },
        {
          prop: "itemName",
          label: "费用项",
          minWidth: "120px",
          // sortable: true,
        },
         {
          slot: "contractCode",
        },
      ];
    },
    }
}
</script>
<style lang="scss" scoped>
.pay {
  height: 100%;
  background-color: #ebebeb;
}
.rs-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.bg-purple-dark {
  background-color: #ffffff;
  color: black;
  font-weight: bold;
  font-size: 15px;
  padding-left: 20px;
  display: flex;
  align-items: center;
}
.grid-content {
  /* border-radius: 4px; */
  height: 40px;
  line-height: 40px;
}
.main{
    margin-top: 10px;
    padding: 10px;
}
.contractCode {
  height: 100px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-around;
 background: #f3f7ff;
}
.contractCode div {
  text-align: center;
  line-height: 2;
  font-size: 16px;
  margin: 5px;
}
.contractCodecolor {
  color: burlywood;
  font-size: 16px;
}
.contractCodecolor span {
  font-size: 14px;
}
.resultContent{
    background: white;
}
.fotter{
     padding: 10px;
}
.main_Fotter{
    background: white;
    height: 50px;
    line-height: 50px;
    padding-left: 10px;
   
}
.footer{
    background: white;
    text-align: right;
    height: 50px;
    line-height: 0px;
    padding: 15px
}
</style>